<template>
  <div class="event-details-box pt-0">
    <div class="event-registration-box event-rg-form">
      <div class="event-thankyou-msg">
        <h4 class="mb-4">{{ eventConfig['confirmation-label-thankyou'] }}</h4>
        <b class="event-msg-heading">{{ eventConfig['confirmation-label-details'] }}</b>
        <p>{{ referenceLabel }}<br />{{ amountLabel }}</p>
        <hr v-if="isTickethasIndividual"/>
        <b v-if="isTickethasIndividual">Individual Tickets</b>
        <ul v-if="isTickethasIndividual">
          <li v-for="(person, index) in persons" :key="index">{{ person.firstName }} {{ person.lastName }}</li>
        </ul>
        <p v-if="isTickethasIndividual && receipt.AmountPaid > 0">{{ eventConfig['confirmation-label-taxreceipt'] }}</p>
        <hr v-if="isTicketHasTable"/>
        <b class="event-msg-heading" v-if="isTicketHasTable">{{ eventConfig['confirmation-label-table'] }}</b>
        <p  v-if="isTicketHasTable">{{ eventConfig['confirmation-label-table-details'] }}</p>
       
        <div class="event-btn d-flex flex-wrap"  v-if="isTicketHasTable">
          <a :href="this.$store.state.URL + '/guesttableseating?id=' + receipt.TableBookingCaptainId + '&ck=' + receipt.TableBookingCK + '&ordernumber=' + receipt.TableBookingOrderNumber" class="btn btn-primary">{{ eventConfig['confirmation-label-table-guests'] }}</a>
        </div>
  
      </div>
    </div>
  </div><!-- /.event-else-wrapper -->
</template>

<script>
export default {
  props: {
    tickets: { type: Array, required: true },
    participants: { type: Object, required: true },
    receipt: { type: Object, required: true },
    eventConfig: { type: Object, required: true }
  },
  data: function () {
    return {
      persons: []
    }
  },
  computed: {
    referenceLabel: function () {
      return this.eventConfig['confirmation-label-reference'].replace('{referencenumber}', this.receipt.ReferenceNumber);
    },
    amountLabel: function () {
      return this.eventConfig['confirmation-label-total'].replace('{total}', `$${this.receipt.AmountPaid}`);
    },
    isTicketHasTable: function(){
      let findTable = this.tickets.filter(ticket => ticket.type === 'table');
      if(findTable.length > 0)
      {
        return true;
      }
      return false;
    },
    isTickethasIndividual: function(){
      let findTable = this.tickets.filter(ticket => ticket.type === 'individual');
      if(findTable.length > 0)
      {
        return true;
      }
      return false;
    }
  },
  mounted() {
    const individualTickets = this.tickets.filter(ticket => ticket.type === 'individual');
    individualTickets.forEach(ticket => {
      this.participants[ticket.code].forEach(participant => {
        this.persons.push({ ...participant });
      });
    });
  }
}
</script>
